import Api from './rest/CrmClientApi';

export default new Api();
